import type { SortByItemDefinition } from "./SortBy.types";

export const sortByStoriesItems: SortByItemDefinition[] = [
  {
    value: "price-low-to-high",
    displayName: "Price: low to high ",
  },
  {
    value: "price-high-to-low",
    displayName: "Price: high to low",
  },
  {
    value: "name-asc",
    displayName: "Name: A-Z",
  },
  {
    value: "name-desc",
    displayName: "Name: Z-A",
  },
  {
    value: "newest-first",
    displayName: "Newest first",
  },
  {
    value: "expiring-soon",
    displayName: "Expiring soon",
  },
];
